import { useEffect, useState } from "react";
import { TreatmentsContainerDto } from "@apiModels/TreatmentsContainerDto.csharp";
import { ServiceContainerDto } from "@apiModels/ServiceContainerDto.csharp";
import { DoctorDto } from "@apiModels/DoctorDto.csharp";
import { LocationDto } from "@apiModels/LocationDto.csharp";
import { filterTreatmentItems } from "../Helpers/treatmentsHelpers";

export function useFilteredTreatments(
	treatments: (TreatmentsContainerDto | ServiceContainerDto)[],
	location: LocationDto,
	doctor: DoctorDto,
	defaultTreatmentsContainer?: TreatmentsContainerDto,
	isDoctorPageBooking?: boolean
) {
	const [filteredTreatments, setFiltered] = useState<
		(TreatmentsContainerDto | ServiceContainerDto)[]
	>([]);

	useEffect(() => {
		const result = filterTreatmentItems(treatments, location, doctor, defaultTreatmentsContainer, isDoctorPageBooking);
		setFiltered(result);
	}, [treatments, location, doctor, defaultTreatmentsContainer, isDoctorPageBooking]);

	return filteredTreatments;
}
